<template>
  <el-dialog
    v-bind="$attrs"
    title="Фильтры"
    :width="popupWidth"
    :visible="is_visible"
    :close-on-click-modal="false"
    @close="closeDialog"
    class="dialog"
  >
    <div class="templates" v-if="!loading">
      <div
        class="templates-list"
        v-if="action !== 'update' && action !== 'save'"
      >
        <div class="template-label">
          <label for="templates">Шаблон</label>
          <Dropdown
            id="templates"
            :model="myActiveFilter"
            :field="{
              name: 'template',
              type: 'enum',
              placeholder: 'Шаблоны'
            }"
            :options="savedFilters"
            clearable
            :optionIcon="{
              name: 'DeleteForever',
              color: '#788694',
              action: 'remove-tag'
            }"
            @remove-tag="removeTag"
            @set-value="selectTemplate"
          />
        </div>
        <Button
          buttonSize="big"
          class="save-button"
          buttonColor="blue"
          buttonText="Сохранить как шаблон"
          @click="showDialogSave"
          :disabled="noChanges"
        />
      </div>
      <div class="radio-form" v-if="action === 'update' || action === 'save'">
        <Radio
          :disabled="canRewriteTemplate"
          label="update"
          text="Перезаписать"
          :model="action"
          @set-value="changeAction"
        />
        <Radio
          label="save"
          text="Сохранить как новый"
          :model="action"
          @set-value="changeAction"
        />
      </div>
      <div
        class="templates-list"
        v-if="action === 'update' || action === 'save'"
      >
        <div class="template-label">
          <label for="template-name">Название шаблона</label>
          <Input
            id="template-name"
            :model="saved_search_name"
            :field="{
              disabled: action === 'update'
            }"
            @set-value="handleChange"
          />
        </div>
        <Button
          buttonSize="big"
          class="save-button"
          buttonColor="blue"
          buttonText="Отменить"
          @click="cancelSaveTemplate"
        />
        <Button
          buttonSize="big"
          class="save-button"
          buttonColor="darkBlue"
          buttonText="Сохранить"
          @click="saveTemplate"
          :disabled="saved_search_name ? !saved_search_name.length : true"
        />
      </div>
    </div>
    <div class="dialog__inner">
      <Loader size="large" class="dialog__loader" v-if="loading" />
      <div class="filter-frame">
        <el-form
          ref="filterForm"
          :key="filterKey"
          id="filter-form"
          v-if="filters && !loading"
          :model="form"
          :rules="rules"
          size="mini"
          hide-required-asterisk
          class="filter-frame__form"
        >
          <FilterField
            :ref="'field_' + filterKey"
            v-for="(filterKey, i) in Object.keys(filters)"
            :show-field="defer(i)"
            :field="filters[filterKey]"
            :form="form"
            :key="filters[filterKey].name"
            :prop="filters[filterKey].name"
            :rules="rules[filters[filterKey].name]"
            :module="moduleName"
            @set-value="setValue"
            @change-option="changeOption"
          />
        </el-form>
      </div>
    </div>
    <div slot="footer" v-show="!loading">
      <div class="footer footer--auto-width">
        <Button
          v-for="button in buttons"
          :key="button.lbl.name"
          :buttonSize="button.sizeVisualClass"
          :buttonColor="button.colorVisualClass"
          :buttonText="button.lbl.value"
          :disabled="
            (button.type == 'cancelButton' && noChanges) ||
            (button.type == 'searchButton' && !formIsValid)
          "
          @click="btnAction(button)"
          class="footer__button-cancel"
        />
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { store } from '@/store';
import { mixin, form } from '@/utils/mixins';
import { FIELD, MODULE, DIALOG_WIDTH } from '@/utils/constants';
import { setDateFormat } from '@/utils/helpers';
import { Dialog, Form } from 'element-ui';
import { getController } from '@/controllers/request.js';
import Button from 'Elements/Button/Button';
import Dropdown from 'Elements/Select/Dropdown';
import Input from 'Elements/Input/Input';
import Radio from 'Elements/Radio/Radio';
import Defer from '@/utils/defer';
import FilterField from 'Elements/Filters/FilterField';
import Loader from 'Elements/Loader/Loader';

export default {
  inheritAttrs: false,
  mixins: [mixin, form, Defer()],
  props: {
    cancelCallbackOnClose: {
      type: Boolean,
      default: true
    },
    is_visible: {
      type: Boolean
    },
    moduleName: {
      type: String,
      default: MODULE.CANDIDATES_MODULE
    },
    mode: String
  },
  data() {
    const validateSalaryRange = (rule, value, callback) => {
      this.validateNumberRange(false, value, callback, [
        this.form.salary_min_advanced,
        this.form.salary_max_advanced
          ? this.form.salary_max_advanced
          : undefined
      ]);
    };

    const validateAgeRange = (rule, value, callback) => {
      this.validateNumberRange(false, value, callback, [
        this.form.age_min_advanced,
        this.form.age_max_advanced ? this.form.age_max_advanced : undefined
      ]);
    };

    const validateDateEnteredRange = (rule, value, callback) => {
      this.validateDateRange(
        false,
        value,
        callback,
        [
          this.form.start_range_date_entered_advanced,
          this.form.end_range_date_entered_advanced
        ],
        this.datepicker.dateFormat
      );
    };

    const validateDateStatusRange = (rule, value, callback) => {
      this.validateDateRange(
        false,
        value,
        callback,
        [
          this.form.date_entered_from_advanced,
          this.form.date_entered_by_advanced
            ? this.form.date_entered_by_advanced
            : undefined
        ],
        this.datepicker.dateFormat
      );
    };

    return {
      loadMoreNum: 0,
      FIELD,
      datepicker: {
        dateFormat: '',
        timeFormat: 'HH:mm'
      },
      pickerOptions: {
        firstDayOfWeek: 1
      },
      loading: false,
      form: {},
      fieldValue: {},
      originalFilters: {},
      defaultParams: {},
      myActiveFilter: null,
      saved_search_name: '',
      removableTag: null,
      paginOptions: {},
      rules: {
        age_max_advanced: [
          {
            validator: validateAgeRange,
            trigger: 'change'
          }
        ],
        age_min_advanced: [
          {
            validator: validateAgeRange,
            trigger: 'change'
          }
        ],
        start_range_date_entered_advanced: [
          {
            validator: validateDateEnteredRange,
            trigger: 'change'
          }
        ],
        end_range_date_entered_advanced: [
          {
            validator: validateDateEnteredRange,
            trigger: 'change'
          }
        ],

        salary_max_advanced: [
          {
            validator: validateSalaryRange,
            trigger: 'change'
          }
        ],
        date_entered_from_advanced: [
          {
            validator: validateDateStatusRange,
            trigger: 'change'
          }
        ],
        date_entered_by_advanced: [
          {
            validator: validateDateStatusRange,
            trigger: 'change'
          }
        ],
        salary_min_advanced: [
          {
            validator: validateSalaryRange,
            trigger: 'change'
          }
        ]
      },
      action: '',
      loadedFields: 0,
      formIsValid: true,
      filterKey: 0
    };
  },
  async created() {
    this.loading = true;
    this.$set(this.datepicker, 'dateFormat', setDateFormat(this.dateFormat));

    let newIntent = store.state.filters.intents;
    if (
      this.mode == 'Attach' &&
      newIntent.request.request_params?.request_for_template
    ) {
      delete newIntent.request.request_params.request_for_template;
      store.commit('filters/setIntents', newIntent);
    }
    await store.dispatch('filters/getFilterData');

    this.myActiveFilter = this.appliedTemplateName;

    const filters =
      this.mode == 'Attach' || this.moduleName == 'vacancy_candidates'
        ? this.appliedFilters
        : this.filters;

    for (const filterKey in filters) {
      if (
        Object.prototype.toString
          .call(filters[filterKey].value)
          .includes('Object')
      ) {
        const value = Object.values(filters[filterKey].value);
        this.$set(
          this.form,
          filters[filterKey].name,
          typeof value != 'string' ? value : this.formatHtml(value)
        );
        this.$set(
          this.originalFilters,
          filters[filterKey].name,
          filters[filterKey].name ==
            'date_status_modified_advanced_range_choice' ||
            filters[filterKey].name == 'date_entered_advanced_range_choice'
            ? '='
            : null
        );
      } else {
        //если поле типа dynamicMultienum и фильтрация по кандидатам в вакансии
        //или по страницам прикрепления,
        //то заполняем закешированные значения полей
        if (
          (this.moduleName == 'vacancy_candidates' || this.mode == 'Attach') &&
          filters[filterKey].type == FIELD.TYPE.DYNAMICMULTIENAM
        ) {
          const cachedFieldProps =
            store.state.filters.dynamicMultiEnumCache[
              this.moduleName == 'vacancy_candidates'
                ? this.moduleName
                : 'attach'
            ][filters[filterKey].name];
          if (cachedFieldProps) {
            Object.keys(cachedFieldProps).forEach(prop => {
              store.state.filters.filterPopupMetaData.panels[0].rows[
                filters[filterKey].name
              ][prop] = cachedFieldProps[prop];
            });
          }
        }
        const value = filters[filterKey].value;
        if (value)
          this.$set(
            this.form,
            filters[filterKey].name,
            typeof value != 'string' ? value : this.formatHtml(value)
          );
        this.$set(
          this.originalFilters,
          filters[filterKey].name,
          filters[filterKey].name ==
            'date_status_modified_advanced_range_choice' ||
            filters[filterKey].name == 'date_entered_advanced_range_choice'
            ? '='
            : null
        );
      }
    }
    this.loading = false;
  },
  methods: {
    fieldType(type) {
      switch (type) {
        case 'varchar':
        case 'text':
        case 'name':
          return 'text';

        case 'decimal':
        case 'int':
        case 'currency':
          return 'number';

        default:
          return '';
      }
    },
    setValue(name, val, type = '') {
      this.$set(
        this.form,
        name,
        typeof val != 'string' ? val : this.formatHtml(val)
      );
      if (type) {
        this.$refs.filterForm.validate(valid => {
          this.formIsValid = valid ? true : false;
        });
        this.$refs.filterForm.validate();
      }
    },
    filterOptions(search_string, fieldName, url) {
      this.fieldValue[fieldName] = [];

      if (this.form[fieldName] && this.form[fieldName].length) {
        for (let ind = 0; ind < this.form[fieldName].length; ind++) {
          if (
            this.paginOptions &&
            this.paginOptions[fieldName] &&
            this.paginOptions[fieldName].find(
              option =>
                option && option.id && option.id === this.form[fieldName][ind]
            )
          ) {
            this.fieldValue[fieldName].push(
              this.paginOptions[fieldName].find(
                option => option.id === this.form[fieldName][ind]
              )
            );
          } else if (
            this.filters[fieldName] &&
            this.filters[fieldName].options &&
            Object.keys(this.filters[fieldName].options).length &&
            this.filters[fieldName].options[this.form[fieldName][ind]]
          ) {
            this.fieldValue[fieldName].push({
              id: this.form[fieldName][ind],
              name: this.filters[fieldName].options[this.form[fieldName][ind]]
            });
          }
        }
      }
      this.paginOptions[fieldName] = [];
      this.paginOptions[fieldName] = this.fieldValue[fieldName];
      this.setNewOptions(search_string, fieldName, url);
    },
    async setNewOptions(search_string = '', fieldName, url) {
      const iteration =
        this.paginOptions[fieldName].length <= 0
          ? 0
          : this.paginOptions[fieldName].length -
            this.fieldValue[fieldName].length;
      const params = {
        offset: iteration || 0,
        search_string: search_string.trim()
      };

      const { data } = await getController({ url, params });
      if (!data) return;

      this.loadMoreNum = 0;
      this.checkOptions = [];
      let keyOptions = [];

      if (this.fieldValue[fieldName] && this.fieldValue[fieldName].length) {
        keyOptions = [...this.form[fieldName]];
      }

      for (let key in data) {
        this.loadMoreNum++;

        if (typeof data[key] == 'object') {
          if (
            keyOptions.indexOf(data[key].id) == -1 &&
            this.paginOptions &&
            ((this.paginOptions[fieldName] &&
              !this.paginOptions[fieldName].find(
                opt =>
                  opt &&
                  opt.id &&
                  opt.name &&
                  opt.id == data[key].id &&
                  opt.name == this.formatHtml(data[key].name)
              )) ||
              !this.paginOptions[fieldName].length)
          ) {
            const params = {
              id: data[key].id,
              name: this.formatHtml(data[key].name)
            };

            if (data[key].sub_text) {
              params.sub_text = this.formatHtml(data[key].sub_text);
            }

            this.checkOptions = [...this.checkOptions, params];
          }
        } else if (typeof data[key] == 'string') {
          const value = this.formatHtml(data[key]);
          if (
            keyOptions.indexOf(key) == -1 &&
            this.paginOptions &&
            ((this.paginOptions[fieldName] &&
              !this.paginOptions[fieldName].find(
                opt =>
                  opt &&
                  opt.id &&
                  opt.name &&
                  opt.id == key &&
                  opt.name == value
              )) ||
              !this.paginOptions[fieldName].length)
          ) {
            this.checkOptions = [
              ...this.checkOptions,
              { id: key, name: value }
            ];
          }
        }
      }

      this.paginOptions[fieldName] = [
        ...this.paginOptions[fieldName],
        ...this.checkOptions
      ];

      return this.paginOptions[fieldName];
    },
    async btnAction(button) {
      if (button.type == 'searchButton') {
        this.applyFilters(button.intents[1].request, this.form);
        store.commit('filters/setFiltersActive', !this.noChanges);
      } else if (button.type == 'cancelButton') {
        this.clearFilter();
      }
      //исправление отображения dynamicMultienum-полей во вкладке Кандидаты в вакансии
      //и страницах прикрепления
      if (
        button.type == 'searchButton' &&
        (this.moduleName == 'vacancy_candidates' || this.mode == 'Attach')
      ) {
        const moduleName =
          this.moduleName == 'vacancy_candidates' ? this.moduleName : 'attach';
        for (let row in Object.values(this.filters)) {
          const filters = Object.values(this.filters);
          //если у поля тип dynamicMultienum и у него есть значения,
          //то кешируем их
          if (
            filters[row]?.type == FIELD.TYPE.DYNAMICMULTIENAM &&
            this.form[filters[row]?.name]
          ) {
            //устанавливаем опции
            const targetOptionsInRefField =
              this.$refs.field[row]?.$refs.dropdown.$props.options;
            let selectedOptions = {};
            this.form[filters[row]?.name].forEach(optionId => {
              //если мы выбрали шаблон и не изменяли значение поля,
              //то опции храняться в виде объекта
              if (!Array.isArray(targetOptionsInRefField)) {
                selectedOptions = targetOptionsInRefField;
              }
              //иначе это массив подгруженных опций, который надо отфильтровать
              //по выбранным значениям
              else {
                selectedOptions[optionId] = targetOptionsInRefField.filter(
                  option => option.id == optionId
                )[0].name;
              }
            });
            //кешируем опции в стор
            store.commit('filters/setDynamicMultienumFieldProps', {
              module: moduleName,
              fieldName: filters[row]?.name,
              propName: 'options',
              propValue: selectedOptions
            });
            //кешируем значение поля
            store.commit('filters/setDynamicMultienumFieldProps', {
              module: moduleName,
              fieldName: filters[row]?.name,
              propName: 'value',
              propValue: this.form[filters[row]?.name]
            });
            //если мы очистили значение поля, то очищаем и закешированное значение в сторе
          } else if (
            filters[row]?.type == FIELD.TYPE.DYNAMICMULTIENAM &&
            !this.form[filters[row]?.name] &&
            store.state.filters.dynamicMultiEnumCache[
              moduleName
            ].hasOwnProperty(filters[row]?.name)
          ) {
            delete store.state.filters.dynamicMultiEnumCache[moduleName][
              filters[row]?.name
            ];
          }
        }
      }
    },
    closeDialog() {
      store.commit('common/setVisibleDialog', {
        name: 'filters_dialog',
        val: false
      });
    },
    cancelSaveTemplate() {
      this.action = '';
    },
    saveTemplate() {
      this.sendRequest();
    },
    handleChange(name, val) {
      this.saved_search_name = val;
    },
    async applyFilters(request) {
      await store.dispatch('common/applyFilters', {
        module: this.moduleName,
        intents: request,
        filters:
          this.moduleName != 'vacancy_candidates'
            ? this.form
            : {
                ...this.form,
                hidden_stage_ids: store.state.rightPanel.hiddenStages
              },
        orderBy: store.state.filters?.filterConfig?.sortable?.orderBy || '',
        sortOrder: store.state.filters?.filterConfig?.sortable?.sortOrder || '',
        saved_search_select: this.myActiveFilter,
        isAttachment: this.mode == 'Attach'
      });
      this.closeDialog();
    },
    clearFilter() {
      this.myActiveFilter = null;
      this.saved_search_name = '';
      for (const filterKey in this.form) {
        this.$set(
          this.form,
          filterKey,
          filterKey == 'date_status_modified_advanced_range_choice' ||
            filterKey == 'date_entered_advanced_range_choice'
            ? '='
            : null
        );
      }

      let filters = { ...this.filters };

      for (let filter of Object.keys(filters)) {
        filters[filter].value = null;
      }

      store.commit('filters/setPopupMetaDataFiltersRows', filters);
      this.filterKey++;
    },
    async sendFilterRequest(requestParams) {
      const params = {};
      let response = {};

      for (let key in requestParams) {
        if (requestParams[key] != null && requestParams[key])
          params[key] = requestParams[key];
      }

      try {
        response = await getController({ params });
        let newIntent = null;
        if (this.mode == 'Attach') {
          newIntent = { ...this.filterIntents };
          newIntent.request.request_params.request_for_template = true;
        }
        if (newIntent) {
          store.commit('filters/setParam', {
            name: 'intents',
            val: newIntent
          });
        }
        if (params?.saved_search_action == 'save') {
          let config = store.state.filters.filterPopupMetaData;
          let newKey = Object.keys(response.data)[0];
          config.custom_searched.options
            ? (config.custom_searched.options[newKey] = response.data[newKey])
            : (config.custom_searched.options = {
                newKey: response.data[newKey]
              });
          store.commit('filters/setFilterPopupMetaData', config);
          await this.selectTemplate('', newKey);
        } else {
          store.commit('filters/setFiltersConfig', response.data);
        }

        // response = await store.dispatch('filters/getFilterAndSortData');
        // if (response.data.savedSearchData.selected) {
        //   this.myActiveFilter = response.data.custom_searched.value;
        // }
      } catch (error) {
        console.log(error);
      } finally {
        this.action = '';
        this.loading = false;
      }

      return response;
    },
    sendRequest() {
      this.requestSent = true;
      this.loading = true;
      let action = this.action;

      if (
        action == 'save' ||
        action == 'delete' ||
        action == 'select' ||
        action == 'update'
      ) {
        this.defaultParams.searchFormTab = 'advanced_search';
        this.defaultParams.module = 'SavedSearch';
        this.defaultParams.action = 'index';
        this.defaultParams.displayMode = 'spa';
      }

      this.defaultParams.saved_search_name =
        this.action == 'save' ? this.saved_search_name : '';
      this.defaultParams.saved_search_select =
        action == 'delete'
          ? this.removableTag
          : action == 'select' || action == 'update'
          ? this.myActiveFilter || '_none'
          : '_none';
      this.defaultParams.search_module =
        action != 'search' ? this.moduleName : ''; // && !this.page
      this.defaultParams.saved_search_action =
        action != 'search' && action != 'select' ? action : '';

      if (action == 'delete' && this.myActiveFilter) {
        this.defaultParams.after_search_select = this.myActiveFilter;
      }

      return this.sendFilterRequest({ ...this.form, ...this.defaultParams });
    },

    changeAction(lbl, val) {
      this.action = val;
    },
    removeTag(tag) {
      this.removableTag = tag.id;
      this.$delete(this.savedFilters, this.removableTag);

      if (this.removableTag) {
        this.action = 'delete';
        this.sendRequest();
      }
    },
    async selectTemplate(name, val) {
      this.myActiveFilter = val;
      this.saved_search_name = val
        ? store.state.filters.filterPopupMetaData.custom_searched.options[val]
        : '';
      if (!val || !val.length) {
        this.clearFilter();
        return;
      }
      this.defaultParams = {};
      this.action = 'select';

      this.defaultParams.saved_search_select = val;
      this.defaultParams.searchFormTab = 'advanced_search';
      this.defaultParams.module = 'SavedSearch';
      this.defaultParams.action = 'index';
      this.defaultParams.displayMode = 'spa';
      this.defaultParams.search_module = this.moduleName;
      this.defaultParams.orderBy =
        store.state.filters?.filterConfig?.sortable?.orderBy;
      this.defaultParams.sortOrder =
        store.state.filters?.filterConfig?.sortable?.sortOrder;

      let response = await getController({ params: this.defaultParams });
      if (!response.data) return;
      if (!response.data.hasOwnProperty('checkIndication')) {
        response.data.checkIndication = false;
      }
      store.commit('filters/setFiltersConfig', response.data);

      let filters = response.data.filters;
      let filterMetaData = store.state.filters.filterPopupMetaData;

      filterMetaData.panels[0].rows = filters;
      store.commit('filters/setFilterPopupMetaData', filterMetaData);

      for (let filter of Object.keys(response.data.filters)) {
        this.$set(this.form, filter, response.data.filters[filter].value);
        const options = response.data.filters[filter]?.options || [];
        if (
          (response.data.filters[filter].type == 'multiLevelEnum' ||
            response.data.filters[filter].type == 'multiLevelEnumLazy') &&
          this.$refs[`field_${filter}`] &&
          this.$refs[`field_${filter}`][0]
        ) {
          this.$refs[`field_${filter}`][0].changeLabel(
            options.length ? this.formatHtml(options[0].name) : ''
          );
          this.$refs[`field_${filter}`][0].paginOptions[filter] = options;
        }
      }
      // this.sendRequest()
      //   .then(resp => {
      //     let customSearch = resp.data?.custom_search;
      //     let filterValues = resp.data?.panels[0]?.rows;
      //     for (const filterKey in filterValues) {
      //       this.$set(
      //         this.form,
      //         filterValues[filterKey]?.name,
      //         filterValues[filterKey]?.value
      //       );
      //     }
      //     this.saved_search_name = customSearch?.options[customSearch.value];
      //   })
      //   .catch(err =>
      //     this.catchError(
      //       err,
      //       'Ошибка при получении данных после фильтрации',
      //       'error getting filters'
      //     )
      //   );
    },
    showDialogSave() {
      if (this.myActiveFilter) {
        this.action = 'update';
      } else {
        this.action = 'save';
      }
    }
  },
  computed: {
    canRewriteTemplate() {
      return !this.myActiveFilter?.length || false;
    },
    isFiltersApplied() {
      return store.state.filters.filtersActive;
    },
    appliedTemplateName() {
      const templateName =
        this.mode == 'Attach' || this.moduleName == 'vacancy_candidates'
          ? store.state.filters.filterConfig?.savedSearchData?.selected
          : store.state.filters.filterPopupMetaData?.custom_searched?.value ||
            null;
      if (templateName) {
        this.handleChange(
          null,
          store.state.filters?.filterPopupMetaData?.custom_searched?.options[
            templateName
          ]
        );
      }

      return templateName;
    },
    filterIntents() {
      return store.state.filters.intents;
    },
    needToLoadFilters() {
      //кеширование убрано для попапов фильтрации модуля "Кандидаты"
      //из-за проблем с опциями полей типа multiEnum (не подгружались)
      if (
        this.moduleName == MODULE.CANDIDATES_MODULE ||
        this.moduleName == 'vacancy_candidates'
      ) {
        return true;
      } else if (
        this.moduleName == MODULE.VACANCY_MODULE &&
        !store.state.filters.vacancyFiltersLoaded
      ) {
        return true;
      } else if (
        this.moduleName == MODULE.CANDIDATE_RESPONDS &&
        !store.state.filters.respondsFiltersLoaded
      ) {
        return true;
      } else {
        return false;
      }
    },
    popupWidth() {
      return store.state.filters?.intents?.size
        ? DIALOG_WIDTH[store.state.filters.intents.size]
        : DIALOG_WIDTH.S;
    },
    noChanges() {
      let check = true;
      for (let key in this.form) {
        if (
          (!this.originalFilters[key] || this.originalFilters[key] == '') &&
          (!this.form[key] || this.form[key] == '')
        ) {
          continue;
        }
        if (this.originalFilters[key] !== this.form[key]) {
          check = false;
        }
      }
      return check;
    },
    appliedFilters() {
      return {
        ...store.state.filters.filterConfig.custom_filters,
        ...store.state.filters.filterConfig.filters
      };
    },
    filters() {
      return store.state.filters?.filterPopupMetaData?.panels
        ? store.state.filters?.filterPopupMetaData?.panels[0]?.rows
        : {};
    },
    savedFilters() {
      return (
        store.state.filters?.filterPopupMetaData?.custom_searched?.options || {}
      );
    },
    buttons() {
      return store.state.filters?.filterPopupMetaData?.bottom_buttons || {};
    }
  },
  components: {
    'el-dialog': Dialog,
    'el-form': Form,
    Button,
    Dropdown,
    Input,

    Radio,
    FilterField,
    Loader
  }
};
</script>

<style lang="scss" scoped>
.dialog {
  .templates {
    text-align: left;
    flex-direction: column;
    display: flex;
    gap: 16px;
    padding: 24px;
    border-bottom: 1px solid $grey12;

    &-list {
      gap: 16px;
      display: flex;
      align-items: flex-end;

      .template-label {
        display: flex;
        flex-direction: column;

        label {
          font-size: 14px;
          line-height: 24px;
          color: $grey80;
        }
      }
    }
  }

  .filter-frame__items {
    margin-top: 16px !important;
  }

  .radio-form {
    display: flex;
    gap: 16px;
    flex-direction: column;
    align-items: flex-start;
  }

  .save-template {
    display: flex;
  }

  .switchers-item {
    flex-direction: row;
    width: 100%;
    font-size: 15px;
    line-height: 24px;
    color: $grey80;
    align-items: center;
    justify-content: space-between;
    display: flex;
  }

  ::v-deep .el-button {
    margin: 0;
  }

  ::v-deep .el-dialog__body {
    padding: 0px !important;
  }

  ::v-deep .dialog__loader {
    display: flex;
    justify-content: center;
  }

  ::v-deep .dialog__inner {
    display: flex;
    justify-content: center;
    padding: 24px;

    .filter-frame__form {
      display: flex;
      flex-direction: column;
      gap: 16px;
    }
  }

  ::v-deep .el-form-item__content {
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    p {
      font-size: 14px;
      line-height: 24px;
      color: $grey80;
    }
  }
}
</style>
